import {Component, Input, OnInit} from '@angular/core';

import * as THEOplayer from '../../../../js-lib/THEOplayer.js';
import {MatSnackBar, MatSnackBarVerticalPosition} from '@angular/material/snack-bar';
import {MatSnackBarHorizontalPosition} from '@angular/material/snack-bar/snack-bar-config';

// declare var THEOplayer: any;

@Component({
  selector: 'app-theoplayer',
  templateUrl: './theoplayer.component.html',
  styleUrls: ['./theoplayer.component.scss']
})
export class TheoplayerComponent implements OnInit {

  @Input() streamSrc: string;

  constructor(private snackbar: MatSnackBar) { }

  ngOnInit() {
    this.createPlayer();
  }

  createPlayer() {
    const element = document.querySelector('.theoplayer-container');

    const player = new THEOplayer.Player(element, {
      libraryLocation: 'https://cdn.myth.theoplayer.com/3c5a2a06-7d4c-49ba-98bb-1f8ea34a5981',
      license: 'sZP7IYe6T6fzTuCz3L113mklIDhcFSac3lB-CKIe06ziIQhcCKBoCShZ0oC6FOPlUY3zWokgbgjNIOf9fKPgCL5kTDPgFSBZ0oa-3QaoI6k13ubiFSUeCl110S1g3SIg36fVfK4_bQgZCYxNWoryIQXzImf90SCc3L0k3LCi0u5i0Oi6Io4pIYP1UQgqWgjeCYxgflEc3lBZ0lak3lBo0ubzFOPeWok1dDrLYtA1Ioh6TgV6UQ1gWtAVCYggb6rlWoz6FOPVWo31WQ1qbta6FOfJfgzVfKxqWDXNWG3ybojkbK3gflNWfGxEIDjiWQXrIYfpCoj-f6i6WQjlCDcEWt3zf6i6v6PUFOPLIQ-LflNWfK1zWDikfgzVfG3gWKxydDkibK4LbogqW6f9UwPkIYz',
    });

    player.source = {
      sources : [{
        src : this.streamSrc,
        type : 'application/x-mpegurl' // sets type to MPEG-DASH
      }]
    };

    player.network.addEventListener('offline', (() => {
      this.showSnackbar();
    }));
  }

  showSnackbar() {
    const horizontalPosition: MatSnackBarHorizontalPosition = 'center';
    const verticalPosition: MatSnackBarVerticalPosition = 'top';

    this.snackbar.open('Stream is not running.', '', {
      duration: 5000,
      horizontalPosition,
      verticalPosition
    });
  }

}
